let config = {}

if (window.dbsProductsReviewsConfig) {
  config = {
    manufacturerIds: window.dbsProductsReviewsConfig.manufacturerIds
  }
}

export const ManufacturerListConfig = config



// WEBPACK FOOTER //
// ./src/config/manufacturerListConfig.js